import PropTypes from 'prop-types'

import { Box, Checkbox, ListItem } from '@domain-group/suit-theme'

const ApplicationListItem = (props) => {
  const {
    application,
    callbacks: {
      toggleApplications,
    },
    checked,
  } = props

  return (
    <ListItem.WithCheckbox
      boxProps={{ border: 'none' }}
      checkbox={<Checkbox checked={checked} onClick={() => toggleApplications()} />}
      disableHover
    >
      <Box color="bodyFontColor" fontSize="small">
        {application.value}
      </Box>
    </ListItem.WithCheckbox>
  )
}

ApplicationListItem.propTypes = {
  application: PropTypes.object.isRequired,
  callbacks: PropTypes.shape({
    toggleApplications: PropTypes.func.isRequired,
  }).isRequired,
  checked: PropTypes.bool,
}

export default ApplicationListItem
